import {
    ADD_FLIGHT_TO_JET_LAG_TRIP,
    UPDATE_FLIGHT_TO_JET_LAG_TRIP,
    REMOVE_FLIGHT_FROM_JET_LAG_TRIP,
    SAVE_JET_LAG_TRIP,
    FETCH_JET_LAG_TRIPS,
    RESET_JET_LAG_TRIP,
    FETCH_DAILY_JET_LAG_STATUS,
    DELETE_JET_LAG_TRIP,
    ADD_FLIGHTS_TO_STATE,
    UPDATE_JET_LAG_TRIP,
    FETCH_DAILY_JET_LAG_STATUS_SUCCESS
} from './ActionTypes';

export function addFlightToTrip(payload) {
    return {
        type: ADD_FLIGHT_TO_JET_LAG_TRIP,
        payload
    };
}

export function updateFlightToJetLagTrip(payload) {
    return {
        type: UPDATE_FLIGHT_TO_JET_LAG_TRIP,
        payload
    };
}

export function removeFlightFromJetLagTrip(payload) {
    return {
        type: REMOVE_FLIGHT_FROM_JET_LAG_TRIP,
        payload
    };
}

export function saveJetLagTrip(payload) {
    return {
        type: SAVE_JET_LAG_TRIP,
        payload
    };
}

export function resetJetLagTrip() {
    return {
        type: RESET_JET_LAG_TRIP
    };
}

export function fetchDailyJetLagStatus(payload) {
    return {
        type: FETCH_DAILY_JET_LAG_STATUS,
        payload
    };
}

export function fetchJetLagTrips(evictCache = false) {
    return {
        type: FETCH_JET_LAG_TRIPS,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteJetLagTrip(payload) {
    return {
        type: DELETE_JET_LAG_TRIP,
        payload
    };
}

export function addFlightsToState(payload) {
    return {
        type: ADD_FLIGHTS_TO_STATE,
        payload
    };
}

export function updateJetLagTrip(payload) {
    return {
        type: UPDATE_JET_LAG_TRIP,
        payload
    };
}

/**
 * @param {{
 *  calendarDate: string;
 *  data: any;
 *  status: number;
 * }} payload
 */
export const fetchDailyJetLagStatusSuccess = (payload) => ({
    type: FETCH_DAILY_JET_LAG_STATUS_SUCCESS,
    payload
});
